<template>
  <div class="nav" :class="{ active: isOpenMenu }">
    <div class="nav__con">
      <button
        @click="clickArrow('prev')"
        class="nav__btn nav__btn--up"
      ></button>
      <router-link
        to="/event/teasing/index"
        :class="{ 'router-link-exact-active': $route.fullPath === '/' }"
        >{{ $t("menu.main") }}<span></span
      ></router-link>
      <router-link
        to="/event/teasing/showcase2nd"
        :class="[
          { 'router-link-exact-active': $route.name === 'showcase2nd'},
          { 'router-link-exact-active': $route.name === 'showcase' },
        ]"
        >{{ $t("menu.showcase") }}<span></span
      ></router-link>
      <div class="nav__con-sub showcase">
        <router-link to="/event/teasing/showcase2nd"
          >{{ $t("menu.showcase-sub.answer") }}<span></span
        ></router-link>
        <router-link to="/event/teasing/showcase"
          >{{ $t("menu.showcase-sub.theworld") }}<span></span
        ></router-link>
      </div>
      <router-link
        to="/event/teasing/introcharacter"
        :class="[
          { 'router-link-exact-active': $route.name === 'introcharacter'},
          { 'router-link-exact-active': $route.name === 'worldpreview'},
          { 'router-link-exact-active': $route.name === 'introclass'},
          { 'router-link-exact-active': $route.name === 'paradigm' },
        ]"
        >{{ $t("menu.intro") }}<span></span
      ></router-link>
      <div class="nav__con-sub">
        <router-link to="/event/teasing/introcharacter"
          >{{ $t("menu.intro-sub.signaturecharacter") }}<span></span
        ></router-link>
        <router-link to="/event/teasing/worldpreview"
          >{{ $t("menu.intro-sub.signature") }}<span></span
        ></router-link>
        <router-link to="/event/teasing/introclass"
          >{{ $t("menu.intro-sub.class") }}<span></span
        ></router-link>
        <router-link to="/event/teasing/paradigm"
          >{{ $t("menu.intro-sub.paradigm") }}<span></span
        ></router-link>
      </div>
      <router-link
        :class="{ 'router-link-exact-active': $route.name === 'clip' }"
        :to="{ name: 'clip', query: { page: 1 } }"
        >{{ $t("menu.clip") }}<span></span
      ></router-link>
      <!-- <router-link to="/media" >{{$t('menu.media')}}<span></span></router-link> -->
      <router-link to="/event/teasing/purple"
        >{{ $t("menu.purple") }}<span></span
      ></router-link>
      <button
        @click="clickArrow('next')"
        class="nav__btn nav__btn--down"
      ></button>
    </div>
    <button @click="openMenu" class="nav__menu">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <div class="nav__full">
      <div class="nav__full-bg"></div>
      <FrameBook></FrameBook>
      <div class="nav__lang">
        <div class="nav__lang-logo">LineageW</div>
        <div class="nav__lang-line"></div>
        <div class="nav__lang-con">
          <a :class="lang == 'ko' ? 'active' : ''" href="/event/teasing/index?lang=ko">KR</a>
          <a :class="lang == 'en' ? 'active' : ''" href="/event/teasing/index?lang=en">EN</a>
          <a :class="lang == 'zh' ? 'active' : ''" href="/event/teasing/index?lang=zh"
            >ZH-hant</a
          >
          <a :class="lang == 'ja' ? 'active' : ''" href="/event/teasing/index?lang=ja">JP</a>
        </div>
      </div>
      <div class="nav__full-scroll">
        <div class="nav__full-con">
          <router-link
            @click.native="closeMenu"
            to="/event/teasing/index"
            :class="{ 'router-link-exact-active': $route.fullPath === '/' }"
            v-html="$t('menu.main')"
            replace
          ></router-link>
          <router-link
            @click.native="closeMenu"
            to="/event/teasing/showcase2nd"
            :class="{ 'router-link-exact-active': $route.name === 'showcase2nd' }"
            >{{ $t("menu.showcase") }}<span></span
          ></router-link>
          <div class="nav__full-con-sub showcase-area">
            <router-link
              @click.native="closeMenu"
              class="intro__menu-btn--1"
              to="/event/teasing/showcase2nd"
              >{{ $t("menu.showcase-sub.answer") }}<span></span
            ></router-link>
            <router-link
              @click.native="closeMenu"
              class="intro__menu-btn--2"
              to="/event/teasing/showcase"
              >{{ $t("menu.showcase-sub.theworld") }}<span></span
            ></router-link>
          </div>
          <router-link
            @click.native="closeMenu"
            to="/event/teasing/introcharacter"
            :class="{ 'router-link-exact-active': $route.name === 'introcharacter' }"
            >{{ $t("menu.intro") }}<span></span
          ></router-link>
          <div class="nav__full-con-sub paradigm-area">
            <router-link
              @click.native="closeMenu"
              class="intro__menu-btn--1"
              to="/event/teasing/introcharacter"
              >{{ $t("menu.intro-sub.signaturecharacter") }}<span></span
            ></router-link>
            <router-link
              @click.native="closeMenu"
              class="intro__menu-btn--2"
              to="/event/teasing/worldpreview"
              >{{ $t("menu.intro-sub.signature") }}<span></span
            ></router-link>
            <router-link
              @click.native="closeMenu"
              class="intro__menu-btn--3"
              to="/event/teasing/introclass"
              >{{ $t("menu.intro-sub.class") }}<span></span
            ></router-link>
            <router-link
              @click.native="closeMenu"
              class="intro__menu-btn--4"
              to="/event/teasing/paradigm"
              >{{ $t("menu.intro-sub.paradigm") }}<span></span
            ></router-link>
          </div>
          <router-link
            @click.native="closeMenu"
            :class="{ 'router-link-exact-active': $route.name === 'clip' }"
            :to="{ name: 'clip', query: { page: 1 } }"
            v-html="$t('menu.clip')"
            replace
          ></router-link>
          <!--
          <div class="nav__full-con-sub">
            <button
              class="clip__menu-btn--1"
              @click="clipMenuClick(1)"
              v-html="$t('menu.clip-sub.clip-1')"
            ></button>
            <button
              class="clip__menu-btn--2"
              @click="clipMenuClick(2)"
              v-html="$t('menu.clip-sub.clip-2')"
            ></button>
            <button
              class="clip__menu-btn--3"
              @click="clipMenuClick(3)"
              v-html="$t('menu.clip-sub.clip-3')"
            ></button>
            <button
              class="clip__menu-btn--4"
              @click="clipMenuClick(4)"
              v-html="$t('menu.clip-sub.clip-4')"
            ></button>
            <button
              class="clip__menu-btn--5"
              @click="clipMenuClick(5)"
              v-html="$t('menu.clip-sub.clip-5')"
            ></button>
          </div>
          -->
          <!-- <router-link @click.native="closeMenu" to="/media" >{{$t('menu.media')}}<span></span></router-link> -->
          <router-link @click.native="closeMenu" to="/event/teasing/purple"
            >{{ $t("menu.purple") }}<span></span
          ></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import routerControll from "@/utils/routerControll";

export default {
  name: "navi",
  components: { FrameBook },
  data() {
    return {
      isOpenMenu: false,
      clipMenus: [],
      initMotion: null,
    };
  },
  computed: {
    ...mapState([
      "contentsData",
      "isMovePage",
      "currentPage",
      "clipQuery",
      "lang",
      "country",
      "isIntro",
    ]),
    ...mapGetters(["getPreorderURL"]),
  },
  methods: {
    ...mapMutations(["setPageMoveType", "setIsLayer"]),
    openMenu() {
      if (this.isMovePage) return;
      if (!this.isOpenMenu) {
        gsap.fromTo(
          this.$el.querySelector(".nav__full-bg"),
          0.3,
          { scale: 1.2, opacity: 0 },
          { scale: 1, opacity: 1 }
        );
        gsap.fromTo(
          this.$el.querySelector(".nav__lang"),
          0.3,
          { y: 0, opacity: 0 },
          { y: 0, opacity: 1, delay: 0.2, ease: "power2.easeOut" }
        );
        gsap.fromTo(
          this.$el.querySelector(".nav__lang-line"),
          0.3,
          { scaleX: 0.1, opacity: 0 },
          { scaleX: 1, opacity: 1, delay: 0.3, ease: "power2.easeOut" }
        );
        gsap.fromTo(
          this.$el.querySelectorAll(".nav__lang-con a"),
          0.3,
          { y: -50, opacity: 0 },
          { y: 0, opacity: 1, delay: 0.2, ease: "power2.easeOut" }
        );
        gsap.fromTo(
          this.$el.querySelectorAll(".nav__full-con a"),
          0.3,
          { y: 0, opacity: 0 },
          { y: 0, opacity: 1, delay: 0.2, stagger: 0.05 }
        );
        gsap.fromTo(
          this.$el.querySelectorAll(".nav__full-con button"),
          0.3,
          { y: 0, opacity: 0 },
          { y: 0, opacity: 1, delay: 0.4, stagger: 0.05 }
        );

        //  this.setIsIntro(true);
      } else {
        // this.setIsIntro(false);
      }
      this.isOpenMenu = !this.isOpenMenu;

      //this.$el.
    },
    closeMenu() {
      this.isOpenMenu = false;
    },
    clipMenuClick(page) {
      this.closeMenu();
      if (this.clipQuery == page) return;
      this.$router.push({ name: "clip", query: { page: page } });
    },
    addRouter(obj) {
      router.push({ name: obj.name, query: { page: obj.page } });
    },
    clickArrow(arrow) {
      routerControll(arrow);
    },
  },
  mounted() {
    this.clipMenus = this.$el.querySelectorAll(".nav__con-sub > a");
    this.clipFullMenus = this.$el.querySelectorAll(
      ".nav__full-con-sub > button"
    );

    this.initMotion = new gsap.timeline({ paused: true });
    this.initMotion
      .to(this.$el.querySelector(".nav__con"), 0.5, {
        autoAlpha: 1,
        ease: "expo.easeInOut",
      })
      .to(
        this.$el.querySelector(".nav__menu"),
        0.5,
        { autoAlpha: 1, ease: "expo.easeInOut" },
        "-=0.5"
      );

    this.$watch("clipQuery", (val) => {
      $(this.clipFullMenus).removeClass("router-link-exact-active");
      $(this.clipFullMenus[val - 1]).addClass("router-link-exact-active");
    });
    this.$watch("isIntro", (val) => {
      if (!val) this.initMotion.play();
    });
  },
  watch: {},
};
</script>

<style lang="scss">
.nav {
  z-index: 11;
  pointer-events: none;
  &__con {
    @include position(
      $position: absolute,
      $top: 50%,
      $right: 79px,
      $width: 25px
    );
    overflow: visible;
    z-index: 10;
    opacity: 0;
    pointer-events: all;
    &:before {
      @include position(
        $position: absolute,
        $top: 50%,
        $right: -79px,
        $width: 645px,
        $height: 1046px
      );
      @include bg($bg: "../assets/img/navi_bg.png", $position: 0px 50%);
      content: "";
      z-index: -1;

      pointer-events: none;
    }
    &:after {
      @include position(
        $position: absolute,
        $top: 50%,
        $right: -79px,
        $width: 375px,
        $height: 666px
      );
      @include bg($bg: "../assets/img/navi_bg_2nd.png", $position: 0px 50%);
      content: "";
      z-index: -1;

      pointer-events: none;
    }
    > a {
      @include position(
        $position: relative,
        $left: -176px,
        $width: 200px,
        $height: 38px
      );
      display: block;
      overflow: visible;
      text-align: right;
      padding-right: 36px;
      font-size: 16px;
      line-height: 38px;
      color: #c2b9a4;
      text-shadow: 1px 1px 5px #000;
      opacity: 0.5;
      /*
      &:nth-of-type(5):after{
        position:absolute;
        right: 24px;
        top: 11px;
        display: inline-block;
        content: "";
        width: 13px;
        height: 12px;
        @include bg($bg: "../assets/img/navi_pt.png");
      }*/
      .en &:nth-of-type(3){
        width: 300px;
        left:-276px;
      }
      > span {
        @include position(
          $position: absolute,
          $top: 9px,
          $right: 0px,
          $width: 22px,
          $height: 24px
        );
        display: block;
        transition: 0.3s;
        @include bg($bg: "../assets/img/navi_bl.png", $position: 0px 0px);
        &:before {
          @include position(
            $position: absolute,
            $top: 0px,
            $left: 0px,
            $width: 100%,
            $height: 100%
          );
          @include bg($bg: "../assets/img/navi_bl.png", $position: -22px 0px);
          content: "";
          opacity: 0;
          transform: scale(0.2);
          transition: 0.3s;
        }
        &:after {
          @include position(
            $position: absolute,
            $top: -8px,
            $left: 8px,
            $width: 0px,
            $height: 24px
          );
          @include bg($bg: "../assets/img/navi_bl_ef.png");
          content: "";
          opacity: 0;
          transition: 0.3s;
        }
        &.link {
          @include bg(
            $bg: "../assets/img/navi_icon_link.png",
            $position: 50% -3px
          );
          &:after {
            display: none;
          }
          &:before {
            display: none;
          }
        }
      }
      &:hover,
      &.router-link-exact-active,
      &.router-link-active {
        color: #f0d49a;
        font-size: 16px;
        opacity: 1;
        transition: 0.3s;
        text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.6);
        > span {
          &:before {
            opacity: 1;
            transform: scale(1);
            transition: 0.3s;
          }
          &:after {
            opacity: 1;
            transition: 0.3s 0.1s;
            width: 43px;
            left: -10px;
            top: -11px;
          }
        }
      }

      &.router-link-exact-active,
      &.router-link-active {
        & + .nav__con-sub {
          display: block;
        }
      }
    }
    &-sub {
      display: none;
      > a {
        @include position(
          $position: relative,
          $left: -206px,
          $width: 203px,
          $height: 39px
        );
        display: block;
        overflow: visible;
        text-align: right;
        padding-right: 33px;
        font-size: 16px;
        line-height: 39px;
        color: #c2b9a4;
        text-shadow: 1px 1px 5px #000;
        opacity: 0.5;
        left: -190px;
        transition: 0.3s;
        > span {
          @include position(
            $position: absolute,
            $top: 15px,
            $right: 0px,
            $width: 23px,
            $height: 13px
          );
          display: block;
          transition: 0.3s;
          opacity: 0;
          right: 10px;
          @include bg($bg: "../assets/img/navi_sub_bl.png", $position: 0px 0px);
        }

        &:hover,
        &.router-link-exact-active,
        &.router-link-active {
          color: #c2b9a4;
          opacity: 1;
          transition: 0.3s;
          left: -208px;
          > span {
            right: 0px;
            opacity: 1;
            transition: 0.3s;
          }
        }
      }
    }
  }
  &__btn {
    display: block;
    width: 25px;
    height: 20px;
    @include bg($bg: "../assets/img/navi_arrow.png");
    margin: 18px 0;
    &--down {
      transform: rotate(-180deg);
    }
  }
  &__menu {
    @include position(
      $position: absolute,
      $width: 50px,
      $height: 40px,
      $top: 68px,
      $left: 81px
    );
    z-index: 14;
    transition: 0.3s;
    opacity: 0;
    pointer-events: all;

    &:before {
      opacity: 0;
      @include position(
        $position: absolute,
        $top: -28px,
        $left: -23px,
        $width: 96px,
        $height: 96px
      );
      @include bg($bg: "../assets/img/icon_ef.png");
      content: "";
      pointer-events: none;
      transition: 0.3s;
    }

    &:after {
      opacity: 0;
      @include position(
        $position: absolute,
        $top: 0px,
        $left: 5px,
        $width: 41px,
        $height: 41px
      );
      @include bg($bg: "../assets/img/icon_menu_close.png");
      content: "";
      pointer-events: none;
      transition: 0.3s;
      .active & {
        opacity: 1;
        transition: 0.3s 0.05s;
      }
    }
    &:hover {
      &:before {
        opacity: 1;
        transition: 0.3s;
      }
    }
    > span {
      @include position(
        $position: absolute,
        $width: 50px,
        $height: 13px,
        $top: 0px,
        $left: 0
      );
      @include bg($bg: "../assets/img/icon_menu.png");
      &:nth-child(2) {
        top: 13px;
        background-position: 50% -13px;
      }
      &:nth-child(3) {
        top: 26px;
        background-position: 0 -26px;
      }
      transition: 0.3s;
      .active & {
        transform-origin: 50% 50%;
        &:nth-child(2) {
          width: 0px;
          left: 25px;
        }
        &:nth-child(1) {
          top: 13px;
          transform: rotate(45deg);
          opacity: 0;
        }
        &:nth-child(3) {
          top: 13px;
          transform: rotate(-45deg);

          opacity: 0;
        }
      }
    }
  }
  &__full {
    display: none;
    //@include bg($bg: '../assets/img/navi_guide_m.jpg');
    //background-size: 100% auto;
    @include position(
      $position: absolute,
      $width: 100%,
      $height: 100%,
      $top: 0,
      $left: 0
    );
    z-index: 13;
    pointer-events: all;
    &-bg {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: 0,
        $left: 0
      );
      @include bg($bg: "../assets/img/navi_full_bg.jpg", $cover: cover);
    }
    &-con {
      z-index: 14;
      @include position(
        $position: absolute,
        $width: 500px,
        $height: 900px,
        $top: 50%,
        $left: 50%
      );
      margin: -445px 0 0 144px;

      transform: scale(0.8);
      > a {
        position: relative;
        display: block;
        width: 499px;
        height: 90px;
        @include hide-text;
        background-position-y: -5px;

        .ko & {
          @include bg(
            $bg: "../assets/img/ko/navi_full_txt_1025.png",
            $position: 0 -5px
          );
        }
        /*
        .en & {
          width: 699px;
        }*/
        &:after {
          @include position(
            $position: absolute,
            $width: 100%,
            $height: 100%,
            $top: 0,
            $left: 0
          );
          background-position-y: -5px;

          .ko & {
            @include bg(
              $bg: "../assets/img/ko/navi_full_txt_1025.png",
              $position: -499px -5px
            );
          }
          
          .en & {

            background-position-x: -499px;

          }

          background-position-x: -500px;
          content: "";
          opacity: 0;
          transition: 0.2s;
        }
        
        &:nth-child(1) {
          
          background-position-y: -10px;
          &:after {
            
            background-position-y: -10px;
          }
        }
        &:nth-child(2) {
          height: 85px;
          background-position-y: -100px;
          &:after {
            height: 85px;
            background-position-y: -100px;
          }
        }
        &:nth-of-type(3) {
          //height: 85px;
          background-position-y: -292px;
          &:after {
            //height: 114px;
            background-position-y: -292px;
          }
        }
        &:nth-of-type(4) {
          height: 85px;
          background-position-y: -598px;
          &:after {
            height: 85px;
            background-position-y: -598px;
          }
        }
        &:nth-of-type(5) {
          height: 85px;
          background-position-y: -682px;
          &:after {
            height: 85px;
            background-position-y: -682px;
          }
        }
        &:hover,
        &.router-link-exact-active,
        &.router-link-active {
          &:after {
            opacity: 1;
            transition: 0.2s;
          }
        }
      }
    }

    &-con-sub {
      > button,
      > a {
        position: relative;
        display: block;
        width: 500px;
        height: 33px;
        @include hide-text;
        &:hover,
        &.router-link-exact-active {
          &:after {
            opacity: 1;
            transition: 0.2s;
          }
        }
        .ko & {
          @include bg(
            $bg: "../assets/img/ko/navi_full_txt_1025.png",
            $position: 0px -400px
          );
        }
        background-position-y: -400px;
        margin-bottom: 24px;
        &:nth-of-type(1){
          margin-bottom: 12px;
        }
        &:after {
          @include position(
            $position: absolute,
            $width: 100%,
            $height: 100%,
            $top: 0,
            $left: 0
          );
          .ko & {
            @include bg(
              $bg: "../assets/img/ko/navi_full_txt_1025.png",
              $position: -499px -400px
            );
          }

          background-position: -500px -400px;
          content: "";
          opacity: 0;
          transition: 0.2s;
          
          .en & {
            background-position-x: -499px;
          }
        }

        &.clip__menu-btn {
          &--1 {
            background-position-y: -400px;

            &:after {
              background-position-y: -400px;
            }
          }
        }

        &.clip__menu-btn {
          &--1 {
            background-position-y: -616px;
            &:after {
              background-position-y: -616px;
            }
          }
          &--2 {
            background-position-y: -673px;
            &:after {
              background-position-y: -673px;
            }
          }
          &--3 {
            background-position-y: -730px;
            &:after {
              background-position-y: -730px;
            }
          }
          &--4 {
            background-position-y: -788px;
            &:after {
              background-position-y: -788px;
            }
          }
          &--5 {
            background-position-y: -846px;
            &:after {
              background-position-y: -846px;
            }
          }
        }
      }
      &.showcase-area{
        a{
          &:nth-of-type(1){background-position-y: -189px;
            &:after {
              background-position-y: -189px;
            }
          }
          &:nth-of-type(2){background-position-y: -240px;
          margin-bottom: 24px;
            &:after {
              margin-bottom: 24px;
              background-position-y: -240px;
            }
          }
        }
      }
      &.paradigm-area{
        a{
          &:nth-of-type(1){background-position-y: -383px;
          margin-bottom: 12px;
            &:after {
              margin-bottom: 12px;
              background-position-y: -383px;
            }
          }
          &:nth-of-type(2){background-position-y: -435px;
          margin-bottom: 12px;
            &:after {
              margin-bottom: 12px;
              background-position-y: -435px;
            }
          }
          &:nth-of-type(3){background-position-y: -487px;
          margin-bottom: 12px;
            &:after {
              margin-bottom: 12px;
              background-position-y: -487px;
            }
          }
          &:nth-of-type(4){background-position-y: -539px;
          margin-bottom: 24px;
            &:after {
              margin-bottom: 24px;
              background-position-y: -539px;
            }
          }
        }
      }
    }

    .active & {
      display: block;
    }
  }
  &__lang {
    @include position(
      $position: absolute,
      $width: 100%,
      $height: 100%,
      $top: 0,
      $left: 0
    );
    z-index: 13;
    &-logo {
      @include position(
        $position: absolute,
        $width: 515px,
        $height: 209px,
        $top: 50%,
        $left: 25%
      );
      @include bg($bg: "../assets/img/navi_logo.png", $cover: cover);
      @include hide-text;
      margin: -183px 0 0 -229px;
    }
    &-line {
      @include position(
        $position: absolute,
        $width: 577px,
        $height: 37px,
        $top: 50%,
        $left: 25%
      );
      @include bg($bg: "../assets/img/lang_bg.png", $cover: cover);
      margin: 0px 0 0 -250px;
    }
    &-con {
      @include position(
        $position: absolute,
        $width: 420px,
        $height: 50px,
        $top: 50%,
        $left: 25%
      );
      margin: 0px 0 0 -185px;
      padding-top: 18px;
      text-align: center;
      transform: scale(0.8);
      > a {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 25px;
        @include bg($bg: "../assets/img/lang_txt.png", $position: 0 0);
        @include hide-text;
        margin: 0 15px;
        &:after {
          @include position(
            $position: absolute,
            $width: 100%,
            $height: 100%,
            $top: 0,
            $left: 0
          );
          @include bg($bg: "../assets/img/lang_txt.png", $position: 0 100%);
          content: "";
          opacity: 0;
          transition: 0.2s;
        }
        &:nth-child(2) {
          width: 76px;
          background-position-x: -96px;
          &:after {
            background-position-x: -96px;
          }
        }
        &:nth-child(3) {
          width: 86px;
          background-position-x: -205px;
          &:after {
            background-position-x: -205px;
          }
        }
        &:nth-child(4) {
          width: 62px;
          background-position-x: -324px;
          &:after {
            background-position-x: -324px;
          }
        }
        &.active,
        &:hover {
          &:after {
            opacity: 1;
            transition: 0.2s;
          }
        }
      }
    }
  }

  @include bp(tablet) {
    &__con {
      display: none;
    }
    &__menu {
      transform: scale(0.5);
      top: 25px;
      left: 13px;
      transition: 0s;

      .active & {
        top: 20px;
        left: 15px;
        transition: 0s;
      }
    }
    &__full {
      &-bg {
        @include bg($bg: "../assets/img/navi_full_bg_m.jpg", $cover: cover);
        //display: none;
      }
      &-scroll {
        @include position(
          $position: absolute,
          $width: 100%,
          $height: calc(100% - 146px),
          $top: 146px,
          $left: 0
        );
        padding: 10px 0 0 40px;
        overflow-y: auto;
      }
      &-con {
        @include position(
          $position: relative,
          $width: 100%,
          $height: 600px,
          $top: 0,
          $left: 50%
        );
        margin: 0 0 0 -150px;
        transform-origin: 0 0;
        transform: scale(0.5);
      }
    }
    &__lang {
      &-logo {
        @include position(
          $position: absolute,
          $width: 515px/2,
          $height: 209px/2,
          $top: 6px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/navi_logo.png", $cover: cover);
        @include hide-text;
        margin: 0px 0 0 -126px;
      }
      &-line {
        @include position(
          $position: absolute,
          $width: 460px,
          $height: 37px/2,
          $top: 144px,
          $left: 50%
        );
        background-size: 100% 100%;
        margin: 0px 0 0 -230px;
      }
      &-con {
        top: 75px;
        left: 50%;
        margin-left: -213px;
        text-align: center;
        transform: scale(0.5);
        > a {
          margin: 0 16px;
          overflow: visible;
          &:before {
            @include position(
              $position: absolute,
              $width: 1px,
              $height: 16px,
              $top: 5px,
              $left: -16px
            );
            content: "";
            background: #625d54;
          }
          &:first-child {
            &:before {
              display: none;
            }
          }
        }
      }
    }
    .frame {
      &:before,
      &:after {
        display: none;
      }
    }
  }
  .en & {
    &__full {
      &-con {
        > a {
          background-image: url("../assets/img/en/navi_full_txt_en_1025.png");
          &:after {
            background-image: url("../assets/img/en/navi_full_txt_en_1025.png");
          }
        }
      }
      &-con-sub {
        > button,
        > a {
          background-image: url("../assets/img/en/navi_full_txt_en_1025.png");
          &:after {
            background-image: url("../assets/img/en/navi_full_txt_en_1025.png");
          }
        }
      }
    }
  }
  .ja & {
    &__full {
      &-con {
        > a {
          background-image: url("../assets/img/ja/navi_full_txt_ja_1025.png");
          &:after {
            background-image: url("../assets/img/ja/navi_full_txt_ja_1025.png");
          }
        }
      }
      &-con-sub {
        > button,
        > a {
          background-image: url("../assets/img/ja/navi_full_txt_ja_1025.png");
          &:after {
            background-image: url("../assets/img/ja/navi_full_txt_ja_1025.png");
          }
        }
      }
    }
  }
  .zh & {
    &__full {
      &-con {
        > a {
          background-image: url("../assets/img/zh/navi_full_txt_zh_1025.png");
          &:after {
            background-image: url("../assets/img/zh/navi_full_txt_zh_1025.png");
          }
        }
      }
      &-con-sub {
        > button,
        > a {
          background-image: url("../assets/img/zh/navi_full_txt_zh_1025.png");
          &:after {
            background-image: url("../assets/img/zh/navi_full_txt_zh_1025.png");
          }
        }
      }
    }
  }
}
</style>

